import script from "./BuildingsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuildingsList.vue?vue&type=script&lang=ts&setup=true"

import "./BuildingsList.vue?vue&type=style&index=0&id=516f2dd6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516f2dd6"]])

export default __exports__